import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleLibraryLoaderService } from '../../services/google-library-loader.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { GeoCoordinates } from '../../models/geo.model';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GoogleMapsModule, CommonModule],
})
export class MapComponent implements OnChanges {
  @Input() options: google.maps.MapOptions | undefined;
  @Input() markerCoordinates: GeoCoordinates | undefined = undefined;
  @Output() markerDragEnd = new EventEmitter<GeoCoordinates>();
  @Output() onPinDrop = new EventEmitter<GeoCoordinates>();
  protected readonly location = location;
  private readonly germanyCenter = {
    lat: 51.029743,
    lng: 10.447106,
  };
  readonly baseMapOptions: google.maps.MapOptions = {
    mapId: environment.googleMapId,
    center: this.germanyCenter,
    streetViewControl: false,
    fullscreenControl: false,
    clickableIcons: false,
  };

  constructor(
    private mapLoaderService: GoogleLibraryLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.mapLoaderService.initMapLoader();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options'] && changes['options'].currentValue) {
      this.options = {
        ...this.baseMapOptions,
        ...changes['options'].currentValue,
      };
    }
  }

  onMarkerDragEnd(event: google.maps.MapMouseEvent) {
    this.markerDragEnd.emit({
      latitude: event?.latLng?.lat() ?? 0,
      longitude: event?.latLng?.lng() ?? 0,
    });
  }

  onMapClick(event: google.maps.MapMouseEvent | google.maps.IconMouseEvent) {
    this.markerCoordinates = {
      latitude: event?.latLng?.lat() ?? 0,
      longitude: event?.latLng?.lng() ?? 0,
    };
    this.cdr.detectChanges();
    this.onPinDrop.emit({
      latitude: event?.latLng?.lat() ?? 0,
      longitude: event?.latLng?.lng() ?? 0,
    });
  }
}
